
import { create } from 'zustand';
import { visualLog } from '@/components/debug/VisualDebugger';

export interface ModalState {
  activeModal: string | null;
  modalHistory: string[];
  modalData: any;
  lastPremiumFeatureAttempt: string | null;
  showPremiumModal: boolean;
}

type ModalStore = {
  // Stato attuale
  activeModal: string | null;
  modalHistory: string[];
  modalData: any;
  
  // Premium feature related
  lastPremiumFeatureAttempt: string | null;
  showPremiumModal: boolean;
  
  // Azioni
  setModalData: (data: any) => void;
  openModal: (name: string) => void;
  closeModal: () => void;
  resetModals: () => void;
  setLastPremiumFeatureAttempt: (featureKey: string | null) => void;
  setShowPremiumModal: (show: boolean) => void;
  
  // Helper methods
  isModalOpen: (name: string) => boolean;
  hasActiveModal: () => boolean;
};

export const useModalStore = create<ModalStore>((set, get) => ({
  activeModal: null,
  modalHistory: [],
  modalData: null,
  
  // Premium feature related
  lastPremiumFeatureAttempt: null,
  showPremiumModal: false,
  
  setModalData: (data) => set({ modalData: data }),
  
  openModal: (name) => {
    if (get().activeModal === name) {
      visualLog.modal(`Prevented reopening modal: ${name} (already open)`);
      return;
    }
    
    const currentModal = get().activeModal;
    const newHistory = [...get().modalHistory];
    
    if (currentModal && currentModal !== name) {
      newHistory.push(currentModal);
    }
    
    visualLog.modal(`Opening modal: ${name} (prev: ${currentModal || 'none'})`);
    
    set({ 
      activeModal: name, 
      modalHistory: newHistory
    });
  },
  
  closeModal: () => {
    const currentActive = get().activeModal;
    
    if (!currentActive) {
      visualLog.modal(`Attempted to close modal but none active`);
      return;
    }
    
    const history = [...get().modalHistory];
    const nextModal = history.length > 0 ? history.pop() : null;
    
    visualLog.modal(`Closing modal: ${currentActive} (next: ${nextModal || 'none'})`);
    
    set({
      activeModal: nextModal,
      modalHistory: history
    });
  },

  resetModals: () => {
    visualLog.modal('Resetting modal store');
    set({
      activeModal: null,
      modalHistory: [],
      modalData: null
    });
  },
  
  setLastPremiumFeatureAttempt: (featureKey) => set({ lastPremiumFeatureAttempt: featureKey }),
  setShowPremiumModal: (show) => set({ showPremiumModal: show }),
  
  // Helper per verificare se una specifica modale è aperta
  isModalOpen: (name) => get().activeModal === name,
  hasActiveModal: () => get().activeModal !== null
}));
